module.exports = __webpack_public_path__ + "documents/18f46565ea137dfa5b00fbfa7b66a96a.pdf";